<div class="ep ap">
  <div class="ap-head">
    <div class="ap-head__title">
      <h2 class="ap-title">{{ 'alerts' | translate }}</h2>
      <span class="ap-open-count">{{
        'alertsOpenCount' | translate: { count: counts().all }
      }}</span>
    </div>
    <div class="ap-head__actions">
      @if (hasExpandable()) {
        <button
          type="button"
          class="ap-ghost"
          (click)="toggleAll()"
        >
          {{ (anyOpen() ? 'alertsCollapseAll' : 'alertsExpandAll') | translate }}
        </button>
      }
      <a
        class="ap-iconbtn"
        routerLink="/settings/status"
        [attr.aria-label]="'alertsSystemStatus' | translate"
        [matTooltip]="'alertsSystemStatus' | translate"
        (click)="close()"
      >
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M3 12h4l2-5 4 10 2-5h6"></path>
        </svg>
      </a>
    </div>
  </div>

  <div
    class="ap-filters"
    role="group"
    [attr.aria-label]="'alertsSeverity' | translate"
  >
    @for (f of filters; track f) {
      <button
        type="button"
        class="ap-filter"
        [attr.aria-pressed]="filter() === f"
        (click)="filter.set(f)"
      >
        @if (f !== 'all') {
          <span
            class="ap-dot ap-tier--{{ f }}"
            aria-hidden="true"
          ></span>
        }
        <span>{{ tierLabelKeys[f] | translate }}</span>
        <span class="ap-filter__count">{{ counts()[f] }}</span>
      </button>
    }
  </div>

  <div class="ap-list">
    @for (s of visibleRows(); track s.tier) {
      <section class="ap-section ap-tier--{{ s.tier }}">
        <h3 class="ap-section__head">
          <span
            class="ap-dot"
            aria-hidden="true"
          ></span>
          <span class="ap-section__word">{{ tierLabelKeys[s.tier] | translate }}</span>
          <span class="ap-section__count">{{ s.count }}</span>
        </h3>

        @for (g of s.groups; track g.key) {
          <div class="ap-group">
            @if (g.single; as one) {
              <!-- One alert of its type: the row is the alert and navigates to it. -->
              <div
                class="ap-row"
                [class.ap-has-link]="one.link"
              >
                <ng-container
                  *ngTemplateOutlet="tile; context: { $implicit: g.type }"
                ></ng-container>
                @if (one.link) {
                  <a
                    class="ap-row__main ap-stretch"
                    [routerLink]="one.link"
                    (click)="close()"
                  >
                    <ng-container
                      *ngTemplateOutlet="singleText; context: { $implicit: one }"
                    ></ng-container>
                  </a>
                } @else {
                  <div class="ap-row__main">
                    <ng-container
                      *ngTemplateOutlet="singleText; context: { $implicit: one }"
                    ></ng-container>
                  </div>
                }
                <ng-container
                  *ngTemplateOutlet="trailing; context: { $implicit: one }"
                ></ng-container>
                @if (one.link) {
                  <span
                    class="ap-chevron"
                    aria-hidden="true"
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M9 6l6 6-6 6"></path>
                    </svg>
                  </span>
                }
              </div>
            } @else {
              <button
                type="button"
                class="ap-row ap-has-link"
                [attr.aria-expanded]="isOpen(g.key)"
                [attr.aria-controls]="isOpen(g.key) ? listId(g.key) : null"
                (click)="toggle(g.key)"
              >
                <ng-container
                  *ngTemplateOutlet="tile; context: { $implicit: g.type }"
                ></ng-container>
                <span class="ap-row__main">
                  <span class="ap-row__titleline">
                    <span class="ap-row__title">
                      @if (g.titleKey) {
                        {{ g.titleKey | translate }}
                      } @else {
                        {{ g.title }}
                      }
                    </span>
                    @if (g.count > 1) {
                      <span class="ap-count">{{ g.count }}</span>
                    }
                  </span>
                  <span class="ap-row__summary">
                    {{ g.summary }}
                    @if (g.more) {
                      {{ 'alertsMoreCount' | translate: { count: g.more } }}
                    }
                    @if (g.ordersLate) {
                      · {{ 'alertsOrdersLateCount' | translate: { count: g.ordersLate } }}
                    }
                  </span>
                </span>
                <span
                  class="ap-chevron"
                  [class.ap-is-open]="isOpen(g.key)"
                  aria-hidden="true"
                >
                  <svg viewBox="0 0 24 24">
                    <path d="M6 9l6 6 6-6"></path>
                  </svg>
                </span>
              </button>

              @if (isOpen(g.key)) {
                <ul
                  class="ap-items"
                  [id]="listId(g.key)"
                >
                  @for (it of g.items; track it.id) {
                    <li>
                      <div
                        class="ap-item"
                        [class.ap-has-link]="it.link"
                      >
                        @if (it.link) {
                          <a
                            class="ap-item__main ap-stretch"
                            [routerLink]="it.link"
                            (click)="close()"
                          >
                            <ng-container
                              *ngTemplateOutlet="itemText; context: { $implicit: it }"
                            ></ng-container>
                          </a>
                        } @else {
                          <div class="ap-item__main">
                            <ng-container
                              *ngTemplateOutlet="itemText; context: { $implicit: it }"
                            ></ng-container>
                          </div>
                        }
                        <ng-container
                          *ngTemplateOutlet="trailing; context: { $implicit: it }"
                        ></ng-container>
                        @if (it.link) {
                          <svg
                            class="ap-item__open"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                          >
                            <path d="M14 4h6v6"></path>
                            <path d="M20 4l-9 9"></path>
                            <path
                              d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"
                            ></path>
                          </svg>
                        }
                      </div>

                      @if (it.orders.length) {
                        <ul class="ap-orders">
                          @for (o of it.orders; track o.id) {
                            <li>
                              @if (o.link) {
                                <a
                                  class="ap-order ap-has-link"
                                  [routerLink]="o.link"
                                  [attr.title]="o.description"
                                  (click)="close()"
                                >
                                  <ng-container
                                    *ngTemplateOutlet="orderText; context: { $implicit: o }"
                                  ></ng-container>
                                </a>
                              } @else {
                                <div
                                  class="ap-order"
                                  [attr.title]="o.description"
                                >
                                  <ng-container
                                    *ngTemplateOutlet="orderText; context: { $implicit: o }"
                                  ></ng-container>
                                </div>
                              }
                            </li>
                          }
                        </ul>
                      }
                    </li>
                  }
                </ul>
              }
            }
          </div>
        }
      </section>
    } @empty {
      <div class="ap-empty">
        <span class="ap-empty__title">{{ 'alertsEmpty' | translate }}</span>
        @if (counts().all > 0) {
          <span class="ap-empty__hint">{{ 'alertsEmptyTier' | translate }}</span>
        }
      </div>
    }
  </div>
</div>

<ng-template
  #singleText
  let-it
>
  <span class="ap-row__titleline">
    <span class="ap-row__title">{{ it.alert.title }}</span>
  </span>
  <span
    class="ap-row__summary"
    [matTooltip]="it.tooltip"
    [matTooltipDisabled]="!it.tooltip"
  >
    @if (!it.alert.title?.includes(it.subject)) {
      {{ it.subject }} ·
    }
    <ng-container *ngTemplateOutlet="meta; context: { $implicit: it }"></ng-container>
  </span>
</ng-template>

<ng-template
  #itemText
  let-it
>
  <span class="ap-item__subject">
    @if (it.patternId) {
      <app-punch-pattern-preview [patternId]="it.patternId">{{
        it.subject
      }}</app-punch-pattern-preview>
    } @else {
      {{ it.subject }}
    }
  </span>
  <span
    class="ap-item__meta"
    [matTooltip]="it.tooltip"
    [matTooltipDisabled]="!it.tooltip"
  >
    <ng-container *ngTemplateOutlet="meta; context: { $implicit: it }"></ng-container>
  </span>
  @if (it.alert.percentComplete > 0) {
    <span
      class="ap-progress"
      aria-hidden="true"
    >
      <i [style.width.%]="it.alert.percentComplete * 100"></i>
    </span>
  }
</ng-template>

<ng-template
  #meta
  let-it
>
  @switch (it.meta.kind) {
    @case ('scheduled') {
      {{
        'alertsScheduledLate'
          | translate
            : {
                when: (it.meta.when | date: 'MM/dd/yy') + ' ' + (it.meta.when | date: 'shortTime'),
                ago: (it.meta.when | timeAgo),
              }
      }}
    }
    @case ('unscheduled') {
      {{ 'alertsNoScheduledTime' | translate }}
    }
    @default {
      {{ it.meta.text }}
    }
  }
</ng-template>

<ng-template
  #orderText
  let-o
>
  <span class="ap-order__code">{{ o.code }}</span>
  <span
    class="ap-order__state"
    [class.ap-is-danger]="o.unscheduled"
    >{{ o.state }}</span
  >
</ng-template>

<!-- Right of the text: the Check data flag, then the alert's own actions. -->
<ng-template
  #trailing
  let-it
>
  @if (it.meta.kind === 'unscheduled') {
    <span class="ap-flag">{{ 'alertsCheckData' | translate }}</span>
  }
  @for (action of it.alert.actions ?? []; track $index) {
    @if (action.target !== 'post') {
      <a
        class="ap-action"
        [href]="action.link"
        [target]="action.target"
        [attr.aria-label]="action.title"
        [matTooltip]="action.title"
      >
        <i
          class="mdi mdi-{{ action.icon }}"
          aria-hidden="true"
        ></i>
      </a>
    } @else if (canAct()) {
      <button
        type="button"
        class="ap-action"
        [attr.aria-label]="action.title"
        [matTooltip]="action.title"
        (click)="postAction(action.link)"
      >
        <i
          class="mdi mdi-{{ action.icon }}"
          aria-hidden="true"
        ></i>
      </button>
    }
  }
  @if (it.alert.kbLink) {
    <a
      class="ap-action"
      [href]="it.alert.kbLink"
      target="_blank"
      rel="noopener"
      [attr.aria-label]="'alertsKbArticle' | translate"
      [matTooltip]="'alertsKbArticle' | translate"
    >
      <i
        class="mdi mdi-help-circle"
        aria-hidden="true"
      ></i>
    </a>
  }
</ng-template>

<!-- The type tile: tier fill, a line glyph per type. -->
<ng-template
  #tile
  let-type
>
  <span
    class="ap-tile"
    aria-hidden="true"
  >
    @switch (type) {
      @case ('MachineOffline') {
        <svg viewBox="0 0 24 24">
          <path d="M9 3v4M15 3v4"></path>
          <path d="M7 7h10v4a5 5 0 0 1-10 0z"></path>
          <path d="M12 16v5"></path>
          <path d="M3 3l18 18"></path>
        </svg>
      }
      @case ('TruckLate') {
        <svg viewBox="0 0 24 24">
          <path d="M2 6h11v10H2z"></path>
          <path d="M13 9h4l4 4v3h-8"></path>
          <circle
            cx="6"
            cy="18"
            r="2"
          ></circle>
          <circle
            cx="17"
            cy="18"
            r="2"
          ></circle>
        </svg>
      }
      @case ('ScheduleSlip') {
        <svg viewBox="0 0 24 24">
          <circle
            cx="12"
            cy="12"
            r="9"
          ></circle>
          <path d="M12 7v5l3 2"></path>
        </svg>
      }
      @case ('WarehouseTaskLate') {
        <svg viewBox="0 0 24 24">
          <path d="M3 9l9-5 9 5v11H3z"></path>
          <path d="M7 20v-7h10v7"></path>
          <path d="M7 16h10"></path>
        </svg>
      }
      @case ('Licensing') {
        <svg viewBox="0 0 24 24">
          <circle
            cx="12"
            cy="9"
            r="5"
          ></circle>
          <path d="M9 13.5L7.5 21l4.5-2.5 4.5 2.5L15 13.5"></path>
        </svg>
      }
      @case ('GeneralInfo') {
        <!-- DESIGN-TODO: no glyph designed for GeneralInfo; an info circle. -->
        <svg viewBox="0 0 24 24">
          <circle
            cx="12"
            cy="12"
            r="9"
          ></circle>
          <path d="M12 11v5"></path>
          <path d="M12 8h.01"></path>
        </svg>
      }
      @default {
        <!-- SolutionError's warning triangle; the design has no other glyphs. -->
        <svg viewBox="0 0 24 24">
          <path d="M12 3l9.5 17h-19z"></path>
          <path d="M12 10v4"></path>
          <path d="M12 17h.01"></path>
        </svg>
      }
    }
  </span>
</ng-template>
